export enum NotificationType {
	TRAJECTORY = "trajectory"
}

export enum ActionType {
	CREATE = "CREATE",
	UPDATE = "UPDATE",
	DELETE = "DELETE"
}

export enum ActionTarget {
	FORM = "FORM",
	EVALUATION = "EVALUATION",
	REPORT = "REPORT"
}

export type Notification = {
	id: number;
	type: NotificationType;
	created: string; // ISO format
	read: boolean;
};

export type TrajectoryNotification = Notification & {
	trajectory: number;
	action: ActionType;
	target: ActionTarget;
	targetId: number;
};

export type NotificationOverview = {
	total: number;
	unread: number;
	notifications: Notification[];
};
